export default __webpack_public_path__ + "static/media/NIAS0280.34I-32874_-17922_0.1c23b8f3.jpg";